
export const EmptyState = () => {
  return (
    <div className="text-center text-muted-foreground">
      No approved funds available at the moment.
    </div>
  );
};
